import { useStoreActions } from "../../../contexts";
import { QueryKeys } from "../../../hooks/reactQuery/queryKeys";
import { useQueryState } from "../../../hooks/reactQuery/useQueryState";
export const useCanResyncXero = _ref => {
  let {
    enabled,
    invoiceId
  } = _ref;
  const {
    api
  } = useStoreActions();
  const {
    data,
    isFetching,
    refresh
  } = useQueryState({
    queryKey: [QueryKeys.CanResyncXero, invoiceId],
    queryFn: () => api.invoice.getResyncXeroStatus(invoiceId),
    refreshOnMount: query => {
      var _query$state$data;
      return !!((_query$state$data = query.state.data) !== null && _query$state$data !== void 0 && _query$state$data.canResync);
    },
    enabled
  });
  return {
    canResyncXero: !isFetching && !!(data !== null && data !== void 0 && data.canResync),
    refreshXero: refresh
  };
};